export enum EmailSenderStatusEnum {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}
